import React from "react";

export const CalculatorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM4 4H20V20H4V4ZM6 6V8H18V6H6ZM6 10V12H8V10H6ZM10 10V12H12V10H10ZM14 10V12H16V10H14ZM6 14V16H8V14H6ZM10 14V16H12V14H10ZM14 14V16H16V14H14ZM6 18V20H8V18H6ZM10 18V20H12V18H10ZM14 18V20H16V18H14Z"
      fill="currentColor"
    />
  </svg>
);

export const SecurityIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2ZM12 4.18L19 8.1V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V8.1L12 4.18ZM11 7V13H13V7H11ZM11 15V17H13V15H11Z"
      fill="currentColor"
    />
  </svg>
);

export const CloudIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18Z"
      fill="currentColor"
    />
  </svg>
);

export const ReportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM9 13V19H7V13H9ZM15 13V19H13V13H15ZM11 13V19H13V13H11Z"
      fill="currentColor"
    />
  </svg>
);

export const PriceTagIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 7.5H7.51M3 6V12C3 12.5304 3.21071 13.0391 3.58579 13.4142L11.5858 21.4142C12.3668 22.1953 13.6332 22.1953 14.4142 21.4142L20.4142 15.4142C21.1953 14.6332 21.1953 13.3668 20.4142 12.5858L12.4142 4.58579C12.0391 4.21071 11.5304 4 11 4H5C3.89543 4 3 4.89543 3 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="7.5" cy="7.5" r="0.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const ImportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 16V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V16M16 12L12 16M12 16L8 12M12 16V4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
